import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Box, Button, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { ArrowUpIcon } from '@chakra-ui/icons';

import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { useTranslation } from 'helpers/languages/translations';
import PageHeader from 'layout/pageHeader';
import MProductViewer from './components/molecules/MProductsViewer';

const PATH = 'product-management';
const ID = 'cdm_clientsproduct';
const NAME = 'page.product';

const ProductManagement = () => {
    const navigate = useNavigate();
    const [tabIndex, setTabIndex] = useState(0);
    const translate = useTranslation();

    const userInfo = useGetUserInfoSelector();
    const readonly = !userInfo?.user_groups?.includes(21);

    // todo: change name to organisme for aliases
    const renderTabs = () => (
        <Tabs isLazy onChange={(index) => setTabIndex(index)}>
            <TabList>
                <Tab _focus={{ boxshadow: 'none' }}>{translate('product.list')}</Tab>
            </TabList>
            <TabPanels>
                <TabPanel>
                    <MProductViewer />
                </TabPanel>
            </TabPanels>
        </Tabs>
    );

    return (
        <Box>
            <PageHeader icon={{ name: 'productBis' }} pageTitle="Products" readonly={readonly}>
                <Button
                    onClick={() => {
                        navigate(tabIndex === 0 ? './upload' : './upload-aliases');
                    }}
                    fontSize="14px"
                    h="30px"
                    bg={'white'}
                    variant="outline"
                    leftIcon={<ArrowUpIcon />}
                    isDisabled={readonly}
                >
                    {translate('file.upload')}
                </Button>
            </PageHeader>
            <Box px="32px">{renderTabs()}</Box>
        </Box>
    );
};

export { PATH, ID, NAME };
export default ProductManagement;
